function formatFileDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

function sanitizeFileNamePart(value) {
  if (value === undefined || value === null) return '';
  return String(value)
    .replace(/[\\/:*?"<>|]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function buildDocumentFileName({ customerName, documentNumber, issueDate, fallbackNumberLabel }) {
  const client = sanitizeFileNamePart(customerName) || 'Client';
  const number = sanitizeFileNamePart(documentNumber) || fallbackNumberLabel;
  const date = sanitizeFileNamePart(formatFileDate(issueDate)) || 'Date';
  return `${client} - ${number} - ${date}.pdf`;
}

export function buildQuoteFileName(data = {}) {
  return buildDocumentFileName({
    customerName: data.customer_name,
    documentNumber: data.invoice_number,
    issueDate: data.issue_date,
    fallbackNumberLabel: 'Quote',
  });
}

export function buildInvoiceFileName(data = {}) {
  return buildDocumentFileName({
    customerName: data.customer_name,
    documentNumber: data.invoice_number,
    issueDate: data.issue_date,
    fallbackNumberLabel: 'Invoice',
  });
}
